module.exports = __webpack_public_path__ + "img/pngAut.60834f81.png";